import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { getResourceStudentLevels } from "../../services/ide-apis";
import {getFromCache, setCache} from "../../services/cache-service";

const { Option } = Select;

const ResourceLevel = ({ onChange, studentLevelName }) => {
    document.title = 'Resource Level Loader';

    const [levels, setLevels] = useState([]);
    const [selectedValue, setSelectedValue] = useState(studentLevelName || null);

    useEffect(() => {
        setSelectedValue(studentLevelName || null);
    }, [studentLevelName]);

    const handleLevelChange = (value,option) => {
        if (value === undefined) {
            setSelectedValue(null);
            onChange?.(null);
            return;
        }
        setSelectedValue(value);
        onChange?.(option.data);
    };

    useEffect(() => {
        const cachedData = getFromCache('resourceLevelData');

        if (cachedData) {
            setLevels(cachedData);
            
        } else {
            const loadLevels = async () => {
                try {
                    const response = await getResourceStudentLevels();
                    if (response.data.statusCode === 200 && response.data.resourceStudentLevels.length > 0) {
                        setLevels(response.data.resourceStudentLevels);
                        setCache('resourceLevelData', response.data.resourceStudentLevels)
                    } else {
                        setLevels([]);
                    }
                } catch (error) {
                    console.error('Error fetching levels:', error);
                }
            };
            loadLevels();
        }
        
    }, []);

    return (
        <div>
            <Select
                placeholder="Student proficiency level"
                style={{ width: '100%' }}
                onChange={handleLevelChange}
                value={selectedValue} 
                optionLabelProp="label"
                allowClear
            >
                {levels.map((level) => (
                    <Option key={level._id} value={level.resourceStudentLevelName} data={level} label={level.resourceStudentLevelName}>
                        {level.resourceStudentLevelName}
                    </Option>
                ))}
            </Select>
        </div>
    );
};

export default ResourceLevel;
